const dev = "http://192.168.1.111:5000/api/v1"
const production = "https://lezzet-sebeti.com.tm/api/v1"

export const domain = production